export enum EnvironmentEnum {
	Dev = "dev",
	Stage = "stg",
	Demo = "demo",
	Production = "prd",
	Production_2 = "PRD_2",
	Development = "development",
	Regression = "reg",
}

export type Environment =
	| EnvironmentEnum.Development
	| EnvironmentEnum.Dev
	| EnvironmentEnum.Stage
	| EnvironmentEnum.Demo
	| EnvironmentEnum.Production
	| EnvironmentEnum.Production_2
	| EnvironmentEnum.Regression;
